import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Numeral from 'numeral';
import containerActions from '../../actions';

import closeImg from './img/close.png';
import deleteImg from './img/delete.png';
import editImg from './img/edit.png';
import arrowRight from './img/arrow_right.png';
import './styles.scss';

class CarData extends Component {
  constructor () {
    super();
    this.state = {
      activeImg: '',
      showModalDeleteCar: false
    };
  }
  componentDidMount() {
    if (this.state.activeImg === '') {
      this.changeImg(this.props.carData.listings.media.photo_links[0]);
    }
  }
  showModal = () => {
    this.setState({
      showModalDeleteCar: !this.state.showModalDeleteCar
    });
  }
  closeCarDataPage = () => {
    this.props.SetActionPage('');
  }
  changeImg = (element) => {
    this.setState({
      activeImg: element
    });
  }
  goToEditCarData = () => {
    this.props.SetActionPage('editCarData');
  }
  confirmDelete = () => {
    // eslint-disable-next-line
    this.props.deleteCars([this.props.carData['_id']]);
    this.props.SetActionPage('');
  }
  imgOnload = (e) => {
    e.target.style.opacity = 1;
  }
  render() {
    return (
      <div className="body-carData">
        <div
          className="heder-carData"
          style={this.props.scrollLeft > 1 ? { left: `-${this.props.scrollLeft}px` } : { }}
        >
          <button onClick={this.closeCarDataPage}>
            <img className="closeButton-carData" src={closeImg} alt="" />
          </button>
          <div className="links-carData">
            <span>Cars</span>
            <img src={arrowRight} alt="arr_pic" />
            <span>{`${this.props.carData.listings.build.body_type}s`}</span>
            <img src={arrowRight} alt="arr_pic" />
            <span>{this.props.carData.listings.build.make}</span>
          </div>
        </div>
        <div className="page-carData">
          <div className="title-carData">
            {this.props.carData.listings.build.make}
            {' '}
            {this.props.carData.listings.build.model}
            {' `'}
            {((this.props.carData.listings.build.year).toString()).slice(-2)}
          </div>
          <div className="buttons-carData">
            <button className="deleteButton-carData" onClick={this.showModal}>
              <div className="textButton-carData">
                <img src={deleteImg} alt="delete_pic" />
                <div>DELETE</div>
              </div>
            </button>
            <button className="editButton-carData" onClick={this.goToEditCarData}>
              <div className="textButton-carData">
                <img src={editImg} alt="edit_pic" />
                <div>EDIT</div>
              </div>
            </button>
          </div>
          <div className="data-carData">
            <div className="images-carData">
              <img
                className="mainImg-carData"
                src={this.state.activeImg !== '' ? this.state.activeImg : this.props.carData.listings.media.photo_links[0]}
                alt="car_pic"
                onLoad={this.imgOnload}
              />
              <div className="imgButtonCont-carData">
                {
                  this.props.carData.listings.media.photo_links.map(element =>
                    (
                      <button
                        key={element}
                        onClick={() => this.changeImg(element)}
                        className={element === this.state.activeImg ? '-active' : ''}
                      >
                        <img src={element} alt="mini_cap_pic" onLoad={this.imgOnload} />
                      </button>
                    ))
                }
              </div>
            </div>
            <div className="infoData-carData">
              <div className="tableRow">
                <div className="rowName-carData">Cost:</div>
                <div className="rowValueCost-carData">{Numeral(this.props.carData.listings.price).format('$0,0.00')}</div>
              </div>
              <div className="tableRow">
                <div className="rowName-carData">Manufacturer:</div>
                <div className="rowValue-carData">{this.props.carData.listings.build.make}</div>
              </div>
              <div className="tableRow">
                <div className="rowName-carData">Model:</div>
                <div className="rowValue-carData">{this.props.carData.listings.build.model}</div>
              </div>
              <div className="tableRow">
                <div className="rowName-carData">Production year:</div>
                <div className="rowValue-carData">{this.props.carData.listings.build.year}</div>
              </div>
              <div className="tableRow">
                <div className="rowName-carData">Mileage:</div>
                <div className="rowValue-carData">{Numeral(this.props.carData.listings.miles).format('0,0')}{' km'}</div>
              </div>
              <div className="tableRow">
                <div className="rowName-carData">Color:</div>
                <div className="rowValue-carData">{this.props.carData.listings.exterior_color}</div>
              </div>
              <div className="tableRow">
                <div className="rowName-carData">Transmission:</div>
                <div className="rowValue-carData">{this.props.carData.listings.build.transmission}</div>
              </div>
              <div className="tableRow">
                <div className="rowName-carData">Fuel type:</div>
                <div className="rowValue-carData">{this.props.carData.listings.build.fuel_type}</div>
              </div>
              <div className="tableRow">
                <div className="rowName-carData">Doors:</div>
                <div className="rowValue-carData">{this.props.carData.listings.build.doors}{' doors'}</div>
              </div>
              <div className="tableRow">
                <div className="rowName-carData">Seats:</div>
                <div className="rowValue-carData">{this.props.carData.listings.build.std_seating}{' seats'}</div>
              </div>
            </div>
          </div>
        </div>
        {this.state.showModalDeleteCar &&
          <div className="modalDel-carsActiveMenu">
            <div className="modalForm-carsActiveMenu">
              <div>You want to delete car?</div>
              <button onClick={this.confirmDelete}>YES</button>
              <button onClick={this.showModal}>NO</button>
            </div>
          </div>
        }
      </div>
    );
  }
}

CarData.propTypes = {
  SetActionPage: PropTypes.func.isRequired,
  deleteCars: PropTypes.func.isRequired,
  carData: PropTypes.instanceOf(Object).isRequired,
  scrollLeft: PropTypes.number.isRequired
};
const mapStateToProps = state => ({
  carData: state.careditor.pagesData.carData
});

export default connect(mapStateToProps, containerActions)(CarData);



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/carData/index.js